/**
 * `/$org/apps/$appId`: one app's own page, inside Apps. The registry says
 * which page an app opens (AppDetailPage); iManage keeps its personal
 * connection and review workflow, every other integration its setup page.
 *
 * @module routes/$org.apps.$appId
 */
import { createFileRoute, redirect } from "@tanstack/react-router";

import { AppDetailPage } from "../components/apps/AppDetailPage";
import { AppsFrame } from "../components/apps/AppsFrame";
import { useRegulationOrg } from "../components/regulation/useRegulationOrg";

function AppRouteView() {
  const { org: orgSegment, appId } = Route.useParams();
  const { org } = useRegulationOrg();
  return (
    <AppsFrame>
      <AppDetailPage organizationId={org?.id ?? null} orgSegment={orgSegment} appId={appId} />
    </AppsFrame>
  );
}

export const Route = createFileRoute("/$org/apps/$appId")({
  beforeLoad: async ({ context }) => {
    if (
      context.authGateState.status !== "authenticated" &&
      context.authGateState.status !== "hosted-static"
    ) {
      throw redirect({ to: "/pair", replace: true });
    }
  },
  component: AppRouteView,
});
